import React from "react";

const Concept = props => {
  return (
    <div>
      <p className="step-p"> 
        Peers ask for each other's blocks to determine who has the most up-to-date blockchain.
      </p>
    </div>
  );
};

export default Concept;


// WEBPACK FOOTER //
// ./src/steps/peer-messages/concept.js